/**
 * Known Mastodon instance domains, sourced from the joinmastodon.org API.
 * Used to detect Mastodon post URLs for embedding.
 */
export const MASTODON_SERVERS: ReadonlySet<string> = new Set([
  '23.illuminati.org',
  '4bear.com',
  'ailbhean.co-shaoghal.net',
  'ani.work',
  'apobangpo.space',
  'archaeo.social',
  'arvr.social',
  'augsburg.social',
  'aus.social',
  'babka.social',
  'bahn.social',
  'balkan.fedive.rs',
  'bark.lgbt',
  'biplus.social',
  'birdon.social',
  'blorbo.social',
  'bologna.one',
  'bonn.social',
  'bookstodon.com',
  'burma.social',
  'burningboard.net',
  'bvb.social',
  'bzh.social',
  'c.im',
  'camp.smolnet.org',
  'ceilidh.online',
  'ciberlandia.pt',
  'climatejustice.social',
  'colorid.es',
  'computerfairi.es',
  'corteximplant.com',
  'cultur.social',
  'cupoftea.social',
  'cville.online',
  'cwb.social',
  'cyberplace.social',
  'dariox.club',
  'darmstadt.social',
  'darticulate.com',
  'datasci.social',
  'defcon.social',
  'det.social',
  'devianze.city',
  'disabled.social',
  'discuss.systems',
  'dizl.de',
  'dmv.community',
  'donphan.social',
  'dresden.network',
  'drumstodon.net',
  'drupal.community',
  'elekk.xyz',
  'elizur.me',
  'epicure.social',
  'episcodon.net',
  'epsilon.social',
  'esq.social',
  'est.social',
  'eupolicy.social',
  'expressional.social',
  'fairmove.net',
  'fairy.id',
  'famichiki.jp',
  'fandom.ink',
  'fedi.at',
  'feuerwehr.social',
  'fikaverse.club',
  'flipboard.social',
  'fpl.social',
  'freeradical.zone',
  'freiburg.social',
  'fribygda.no',
  'friendsofdesoto.social',
  'frikiverse.zone',
  'frontrange.co',
  'fulda.social',
  'furries.club',
  'furry.engineer',
  'gamepad.club',
  'gardenstate.social',
  'gaygeek.social',
  'genealysis.social',
  'glasgow.social',
  'graphics.social',
  'growers.social',
  'h-net.social',
  'h4.io',
  'hachyderm.io',
  'hcommons.social',
  'hear-me.social',
  'hessen.social',
  'hispagatos.space',
  'hometech.social',
  'hoosier.social',
  'hostux.social',
  'ieji.de',
  'indieauthors.social',
  'indieweb.social',
  'infosec.exchange',
  'ioc.exchange',
  'is.nota.live',
  'k8s.social',
  'kanoa.de',
  'kcmo.social',
  'khiar.net',
  'kjas.no',
  'kolektiva.social',
  'kurry.social',
  'kzoo.to',
  'learningdisability.social',
  'leipzig.town',
  'lewacki.space',
  'lgbtqia.space',
  'library.love',
  'libretooth.gr',
  'livellosegreto.it',
  'lou.lt',
  'lounge.town',
  'lsbt.me',
  'ludosphere.fr',
  'm.cmx.im',
  'm.otter.homes',
  'machteburch.social',
  'mapstodon.space',
  'mast.dragon-fly.club',
  'mast.hpc.social',
  'mast.lat',
  'masto.es',
  'masto.nobigtech.es',
  'masto.nu',
  'masto.nyc',
  'masto.pt',
  'masto.yttrx.com',
  'mastoart.social',
  'mastodon-belgium.be',
  'mastodon-swiss.org',
  'mastodon.africa',
  'mastodon.au',
  'mastodon.babb.no',
  'mastodon.bachgau.social',
  'mastodon.bahia.no',
  'mastodon.berlin',
  'mastodon.bida.im',
  'mastodon.bot',
  'mastodon.cipherbliss.com',
  'mastodon.com.pl',
  'mastodon.cr',
  'mastodon.education',
  'mastodon.ee',
  'mastodon.energy',
  'mastodon.escepticos.es',
  'mastodon.eus',
  'mastodon.free-solutions.org',
  'mastodon.frl',
  'mastodon.gal',
  'mastodon.gamedev.place',
  'mastodon.green',
  'mastodon.hosnet.fr',
  'mastodon.ie',
  'mastodon.iow.social',
  'mastodon.london',
  'mastodon.me.uk',
  'mastodon.mg',
  'mastodon.ml',
  'mastodon.nl',
  'mastodon.nu',
  'mastodon.ph',
  'mastodon.pirateparty.be',
  'mastodon.pnpde.social',
  'mastodon.scot',
  'mastodon.sdf.org',
  'mastodon.sg',
  'mastodon.social',
  'mastodon.uno',
  'mastodon.uy',
  'mastodon.vlaanderen',
  'mastodon.wien',
  'mastodon.world',
  'mastodonapp.uk',
  'mastodont.cat',
  'mastodontech.de',
  'mastodontti.fi',
  'mastorol.es',
  'mastoturk.org',
  'mastouille.fr',
  'mathstodon.xyz',
  'mcr.wtf',
  'metalhead.club',
  'mikumikudance.cloud',
  'mindly.social',
  'mograph.social',
  'mountains.social',
  'ms.maritime.social',
  'mstdn.animexx.de',
  'mstdn.business',
  'mstdn.ca',
  'mstdn.dk',
  'mstdn.games',
  'mstdn.jp',
  'mstdn.party',
  'mstdn.plus',
  'mstdn.social',
  'muenchen.social',
  'muenster.im',
  'muri.network',
  'musician.social',
  'musicians.today',
  'musicworld.social',
  'mustard.blog',
  'nautical.social',
  'nfld.me',
  'noc.social',
  'nomanssky.social',
  'norcal.social',
  'norden.social',
  'nrw.social',
  'nutmeg.social',
  'nwb.social',
  'occm.cc',
  'ohai.social',
  'okla.social',
  'opalstack.social',
  'opencoaster.net',
  'oslo.town',
  'paktodon.asia',
  'pawb.fun',
  'peoplemaking.games',
  'phpc.social',
  'piaille.fr',
  'planetearth.social',
  'pnw.zone',
  'polsci.social',
  'pouet.chapril.org',
  'poweredbygay.social',
  'privacysafe.social',
  'puntarella.party',
  'qaf.men',
  'qdon.space',
  'rail.chat',
  'raphus.social',
  'retro.pizza',
  'rheinhessen.social',
  'rheinneckar.social',
  'rivals.space',
  'rollenspiel.social',
  'ruby.social',
  'ruhr.social',
  'ruhrpott.social',
  'sakurajima.moe',
  'sciences.social',
  'seocommunity.social',
  'sfba.social',
  'shelter.moe',
  'silversword.online',
  'skastodon.com',
  'snabelen.no',
  'socel.net',
  'social.anoxinon.de',
  'social.cologne',
  'social.diva.exchange',
  'social.ferrocarril.net',
  'social.linux.pizza',
  'social.politicaconciencia.org',
  'social.seattle.wa.us',
  'social.silicon.moe',
  'social.sndevs.com',
  'social.tchncs.de',
  'social.vivaldi.net',
  'squawk.mytransponder.com',
  'stereodon.social',
  'stranger.social',
  'sueden.social',
  'sunny.garden',
  'synapse.cafe',
  'tchafia.be',
  'tea.codes',
  'tech.lgbt',
  'techhub.social',
  'techtoots.com',
  'theatl.social',
  'theblower.au',
  'thecanadian.social',
  'tilde.zone',
  'tkz.one',
  'toad.social',
  'tooot.im',
  'toot.aquilenet.fr',
  'toot.community',
  'toot.funami.tech',
  'toot.garden',
  'toot.kif.rocks',
  'toot.re',
  'toot.si',
  'toot.wales',
  'tooting.ch',
  'toots.nu',
  'troet.cafe',
  'troet.fediverse.at',
  'tuiter.rocks',
  'tyrol.social',
  'union.place',
  'universeodon.com',
  'urbanists.social',
  'uri.life',
  'ursal.zone',
  'urusai.social',
  'veganism.social',
  'vkl.world',
  'vmst.io',
  'voi.social',
  'wargamers.social',
  'wehavecookies.social',
  'wien.rocks',
  'witter.cz',
  'woof.tech',
  'wxw.moe',
  'xarxa.cloud',
]);

